// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Medal48FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Medal48Filled: FC<Medal48FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M24 25.5c-1.5 0-2.792-.542-3.875-1.625C19.042 22.792 18.5 21.5 18.5 20s.542-2.792 1.625-3.875C21.208 15.042 22.5 14.5 24 14.5s2.792.542 3.875 1.625C28.958 17.208 29.5 18.5 29.5 20s-.542 2.792-1.625 3.875C26.792 24.958 25.5 25.5 24 25.5ZM12.2 46V30.8c-1.5-1.567-2.575-3.283-3.225-5.15A17.077 17.077 0 0 1 8 20c0-4.533 1.533-8.333 4.6-11.4C15.667 5.533 19.467 4 24 4s8.333 1.533 11.4 4.6C38.467 11.667 40 15.467 40 20c0 1.9-.325 3.783-.975 5.65-.65 1.867-1.725 3.583-3.225 5.15V46L24 42.05 12.2 46ZM24 33c3.633 0 6.708-1.258 9.225-3.775C35.742 26.708 37 23.633 37 20s-1.258-6.708-3.775-9.225C30.708 8.258 27.633 7 24 7s-6.708 1.258-9.225 3.775C12.258 13.292 11 16.367 11 20s1.258 6.708 3.775 9.225C17.292 31.742 20.367 33 24 33Z" />
        </svg>
    );
};

export default Medal48Filled;
